import { render, staticRenderFns } from "./importResultTable.vue?vue&type=template&id=49c72150&"
import script from "./importResultTable.vue?vue&type=script&lang=js&"
export * from "./importResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports